import { Tooltip } from 'antd';
import useDeclarations from 'hooks/useDeclarations';
import useJobs from 'hooks/useJobs';
import { ReactElement, useMemo, useState } from 'react';
import styled from 'styled-components';
import MRNLookupModal from 'views/declarations/common/misc/MRNLookupModal';
import SearchCustomerButton from 'views/declarations/common/search-customer/SearchCustomerButton';
import { getMrn } from 'views/declarations/utils/declaration-utils';

export const InfoTitle = styled.span`
    font-weight: bold;
    white-space: nowrap;
`;

export const InfoText = styled.span`
    white-space: nowrap;
    max-width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 3rem;
`;

export const InfoWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    align-items: center;
`;

interface Props {
    hasBox44?: boolean | undefined;
    handleViewAllProductsBtn?: () => void;
    handleAddNewProductBtn?: () => Promise<void>;
    viewOnly?: boolean;
    options?: {
        visible?: {
            template?: boolean;
            declaration?: boolean;
            jobId?: boolean;
            ref?: boolean;
            status?: boolean;
            gmrId?: boolean;
            record?: boolean;
            pbnId?: boolean;
            mrn?: boolean;
        };
    };
}

const DeclarationMrnJobInfo = ({
    options = {
        visible: {
            declaration: true,
            jobId: true,
            ref: true,
            status: true,
            template: true,
            gmrId: false,
            pbnId: false,
        },
    },
}: Props): ReactElement => {
    const { declaration } = useDeclarations();
    const { job } = useJobs({ jobId: declaration?.jobId });

    const [MRNLookupModalVisible, setMRNLookupModalVisible] = useState(false);

    const jobId = job?.referenceId;

    const mrn = useMemo(() => declaration && getMrn(declaration), [declaration]);

    const showMRNLookupModal = () => {
        if (!mrn) return;
        setMRNLookupModalVisible(true);
    };
    const hideMRNLookupModal = () => {
        setMRNLookupModalVisible(false);
    };

    return (
        <Container>
            {mrn && (
                <InfoWrapper data-testid="declaration-information-mrn">
                    <InfoTitle>MRN: </InfoTitle>
                    <Tooltip overlay={mrn ?? 'N/A'}>
                        <InfoText onClick={showMRNLookupModal}>{mrn ?? 'N/A'}</InfoText>
                    </Tooltip>
                    {mrn ? (
                        <SearchCustomerButton title="MRN Lookup" compact condensed onClick={showMRNLookupModal} />
                    ) : null}
                </InfoWrapper>
            )}
            {options?.visible?.jobId && (
                <InfoWrapper data-testid="declaration-information-job-id">
                    <InfoTitle>Job ID: </InfoTitle>
                    <InfoText>{jobId}</InfoText>
                </InfoWrapper>
            )}

            <MRNLookupModal open={MRNLookupModalVisible} onCancel={hideMRNLookupModal} />
        </Container>
    );
};

export default DeclarationMrnJobInfo;
